import { SpinnerService } from './../services/spinner.service';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ProductCategoryModel } from '../models/product.category.model';
import { ProductCategoryService } from '../services/productcategory.service';

@Component({
  selector: 'app-landingpage',
  templateUrl: './landingpage.component.html',
  styleUrls: ['./landingpage.component.css']
})
export class LandingpageComponent implements OnInit {

  public productCategories: ProductCategoryModel[] = [];
  baseUrl = environment.baseUrl;

  constructor(public productCategoryService: ProductCategoryService, private spinner: SpinnerService) { 
    const items = { ...localStorage };
  }

  ngOnInit(): void {

    this.spinner.showSpinner();
    this.productCategoryService.getProductCategories()
      .subscribe(
        (data => {
          this.productCategories = data;
        }),
        (error => {
          console.log(error);
        })
      );
    this.spinner.hideSpinner();

  }

  encodeContent = function (data) {
    return encodeURIComponent(data);
  }

}

